import React from 'react';
import { bonuses } from '../../data/curly';
export function BonusSection() {
  return <section className="border-b border-white/5 bg-ink py-20" aria-labelledby="bonus-title" data-id="element-1" data-mp="goyo4fw5jf5n">
      <div className="mx-auto w-full max-w-5xl px-6" data-id="element-2" data-mp="bpc7dwh47gs3">
        <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-3" data-mp="bo1746mvor5q">
          <h2 id="bonus-title" className="font-display text-3xl text-cream sm:text-4xl" data-id="element-4" data-mp="7mz4dftr5wz0">
            Tres bonos incluidos hoy
          </h2>
          <p className="text-sm text-sand" data-id="element-5" data-mp="2r0lg7r7175z">Valor combinado: $72</p>
        </div>

        <ul className="mt-10 divide-y divide-white/10 border-y border-white/10" data-id="element-6" data-mp="3u20iwk8igaio">
          {bonuses.map(bonus => <li key={bonus.title} className="grid gap-2 py-6 sm:grid-cols-[1fr_auto] sm:items-start sm:gap-8" data-id="element-7" data-mp="3p2fj67liny4w">
              <div data-id="element-8" data-mp="3g2sijo0m2wcw">
                <h3 className="font-display text-2xl text-cream" data-id="element-9" data-mp="3g3aq3gsq4x04">{bonus.title}</h3>
                <p className="mt-1 max-w-prose text-sand" data-id="element-10" data-mp="3b5sgrpasofrl">{bonus.description}</p>
              </div>
              <p className="text-sm text-gold sm:text-right" data-id="element-11" data-mp="2r01e10n1pd9f">
                <span className="line-through opacity-60" data-id="element-12" data-mp="2vr9pe27xr8p8">{bonus.value}</span>
                <span className="ml-2 font-semibold uppercase tracking-[0.14em]" data-id="element-13" data-mp="2vte31bvmzm2p">Gratis</span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}